import { createSlice } from "@reduxjs/toolkit";

const movieSlice = createSlice({
    name:"movies",
    initialState: {
        nowPlayingMovies: null,
        trailerVideo: null,
        PopularMovies :null,
        TopRatedMovies: null,
        UpcomingMovies: null,
        RecomendedMovies:null,
        
    },

    reducers:{
        addNowPlayingMovies : (state, action) =>{
            state.nowPlayingMovies = action.payload;
        },
        addPopularMovies : (state, action) =>{
            state.PopularMovies = action.payload;
        },
        addTopRatedMovies: (state, action)=>{
            state.TopRatedMovies = action.payload;
        },
        addUpcomingMovies: (state, action)=>{
            state.UpcomingMovies = action.payload;
        },
        addTrailerVideo: (state, action)=>{
            state.trailerVideo = action.payload;
        },
        addRecomendedMovie: (state, action) =>{
            state.RecomendedMovies = action.payload;
        },
        
        
    }
});

export const {addNowPlayingMovies, addTrailerVideo, addPopularMovies, addTopRatedMovies, addUpcomingMovies, addRecomendedMovie} = movieSlice.actions;

export default movieSlice.reducer;